<template>
  <x-page title="编辑配送人员" :loading="loading" white-background>
    <template v-if="!loading">
      <div :class="_['list-translate']">
        <div :class="_['form-item']">
          <div :class="_['form-name']">姓名</div>
          <van-field
            v-model="name"
            clearable
            :class="_['form-input']"
            placeholder="请输入姓名"
          />
        </div>
        <div :class="_['form-item']">
          <div :class="_['form-name']">联系电话</div>
          <van-field
            v-model="phone"
            clearable
            type="number"
            :maxlength="11"
            :class="_['form-input']"
            placeholder="请输入联系电话"
          />
        </div>
      </div>
      <div :class="_['btn']">
        <van-button
          v-track="{
            name: '编辑配送人员-保存',
            id: 'cl9qgt0n5001ykcug1dufc51z',
          }"
          :class="_.roundBtn"
          round
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          block
          @click="submitSave"
          >保存</van-button
        >
      </div>
    </template>
  </x-page>
</template>

<script>
  import sheetVc from '../components/sheetVc'
  import Vue from 'vue'
  import { yup as _ } from 'vtils/validator'
  import { apiOrderMerchantDeliveryUserAddOrUpdate } from '@/api'
  import { navigateBack } from '@/router'
  import { Toast } from 'vant'
  import { Track } from '@/utils/Track'
  const rules = _.object({
    name: _.string().required('请输入配送人员姓名'),
    phone: _.string()
      .required('请输入配送人员手机号')
      .chineseMobilePhoneNumber('手机号格式不正确'),
  })
  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        page: '编辑配送人员',
      })),
    ],
    data() {
      return {
        name: '',
        phone: '',
        id: '',
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    mounted() {
      if (this.$route.query.user) {
        this.name = JSON.parse(this.$route.query.user).userName
        this.phone = JSON.parse(this.$route.query.user).userPhone
        this.id = JSON.parse(this.$route.query.user).id
      }
    },
    methods: {
      async submitSave() {
        const { data, error } = rules.validatePlusSync({
          phone: this.phone,
          name: this.name,
        })
        if (error) {
          Toast(error.errors[0])
        } else {
          const params = {
            userName: data.name,
            userPhone: data.phone,
          }
          let tip = '成功新增配送人员'
          if (this.id) {
            params.id = this.id
            tip = '成功修改配送人员'
          }
          Toast.loading({
            message: '保存中',
            forbidClick: true,
            loadingType: 'spinner',
            duration: 0,
          })
          await apiOrderMerchantDeliveryUserAddOrUpdate(
            { ...params },
            { hasStoreCode: true },
          )
          Toast.success(tip)
          Toast.clear()
          navigateBack()
          if (sheetVc.addVc !== null) {
            sheetVc.addVc.thatShow = true
            sheetVc.addVc.getUserList()
          }
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .list-translate {
    height: calc(100% - 58px);
    overflow: hidden;
    padding: 0 12px;
    .form-item {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .form-name {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
      }
      .form-input {
        width: 274px;
        min-height: 42px;
        background: #f5f5f5;
        border-radius: 8px;
      }
    }
  }
  .btn {
    width: calc(100% - 24px);
    position: fixed;
    bottom: 0;
    height: 44px;
    padding: 12px;
    .roundBtn {
      width: 100%;
    }
  }
</style>
